import { COLOR_TYPE, ID } from "src/libs/interfaces/layouts"

export default interface IScalarForm {
    type? : SCALAR_TYPES | string 
    title?: string | React.ReactElement 
    subtitle?: string | React.ReactElement 
    field?: string
    prefix?: string | React.ReactElement 
    postfix?: string | React.ReactElement 
    description?: string | React.ReactElement  
    commentary?: string | React.ReactElement 
    pseudoTitle?: string  
    tags?: string[]
    visibleValue?: string | null
    value: string | any 
    values?: any[] 
    default?: string | any 
    className?: string 
    rowClassName?: string 
    rows?: number
    elementClassName?:string
    elementClassName2?:string
    style?: any
    vertical?: VerticalType
    onChange? : ( value: any, file: any, name: string ) => void
    on?: ( value: any, file: any, name: string ) => void
    onClear?: ( field: string ) => void
    editable? : boolean
    notClear?: boolean
    autoFocus?: boolean
    isFileNameHide?: boolean    // Media
    subMenus?: any
    onSubMenu?: () => void
    width?: number | string     // Media
    height?: number | string    // Media, ImageRadioCarousel
    tab?: string                // Media
    id?: ID,
    ID?: ID
    accept?: string | undefined,// Media
    isUploadHide?: boolean,     // Media
    isURLHide?: boolean         // Media
    hideLib?: boolean           // Media
    limitSize?: number          // Media
    multiple?: boolean          // Select
    min?: number                // Slider
    max?: number                // Slider, Upload (per kb)
    component?: string          // External
    paging?: string             // External
    landId?: ID                 // External
    origin?: any
    stepSize? : number          // Slider, ImageRadioCarousel
    labelStepSize? : number     // Slider
    inputStyle?: any
    filter?: any,
    sort?: SortField,
    placeholder?: string
    visualization?: string
    enabledLabel? : string      // Boolean
    disabledLabel? : string     // Boolean
    colorType?: COLOR_TYPE      // Color
    onlyPlainColor?: boolean    // Color
    onlyGradientColor?: boolean // Color 
    onlyPantoneColor?: boolean // Color 
    isMulti?: boolean           // User 
    onlyThisLands?: boolean     // User 
    minimal?:boolean            // tags, date, color
    seed? : string
    reader? :  "readAsText" | "readAsDataURL" | "readAsBinaryString"
    required?: boolean
    noDefault?: boolean 
    ["data-testid"]?: string
}

export type FilterField = {
    
}
export type SortField = {
    field: string,
    order: "ASC" | "DESC"
}

export enum VerticalType {
    HORIZONTAL,
    VERTICAL,
}
export interface IScalarObject {
    enabledForm? :  React.ReactElement
    desabledForm? : React.ReactElement
}

export interface ISingleField {
    _id: ID,
    title: string,
    value?: any
    description?: string
    commentary?: string
}

export enum SCALAR_TYPES {
    STRING="string",
    DATA_TYPE="data_type",
    COMPONENT="component",
    NUMBER="number",
    INT="int",
    SLIDER="slider",
    UPLOAD="upload",
    ADDRESS="address",
    SELECT="select",
    CHECKBOX="checkbox",
    IMAGE_CHECKBOX="image_checkbox",
    RADIO="radio",
    IMAGE_RADIO="image_radio",
    IMAGE_RADIO_CAROUSEL="imag_radio_carousel",
    TEXT="text",
    HTML="html",
    ID="id",
    DATE="date",
    GEO="geo",
    BOOLEAN="boolean",
    COLOR="color",
    RGB="rgb",
    EXTERNAL="external",
    EXTERNAL_ARRAY="external_array",
    EXTERNAL_TAGS="external_tags",
    ARRAY="array",
    JSON="json",
    MEDIA="media",
    GALLERY="gallery",
    EMAIL="email",
    URL="url",
    PHONE="phone",
    PASSWORD="password",
    TAGS="tags",
    LINK="link",
    RELOADITABLE="reloaditabled",
    ICON="icon",
    TITLE="title",
    RUTUBE_ID="rutube_id",
    VK_VIDEO_ID="vk_video_id",
    DZEN_VIDEO_ID="dzen_video_id",
    YOUTUBE_ID="youtube_id",
    YOUTUBE_LIST="youtube_list",
    CHECKBOX_GROUP="checkbox_group",
    RUSSIAN_REGIONS="RussianRegions", 
    POST_STATUS="post_status", 
    TIME_DURATION="time_duration", 
    SPEEDOMETER="speedometer", 
    PERCENTAGE="percentage", 
    DEPTH="depth", 
    USER="user",
    KIND="kind",
    ENUM="enum",
    CSS_PROPERTIES="css_properties",
    CSS_MAGNITUDE="css_magnitude",
    GOOGLE_FONTS="google_fonts",
    EDITING_ARRAY="edited_array",
    BORDER="border",
    BORDER_RADIUS="border_radius",
    OPTIONS="options",
    POPOVER="popover",
    POPOVER_MULTI="popover_multi",
}